import React from 'react';
import Button from '../shared/button/button';
import {useNavigate} from 'react-router-dom';
import {useSelector} from 'react-redux';

import {viewSelector} from '../../selectors/view';

import {menuItems} from '../../constants/menu-items';
import styles from './information.styl';

const CloseButton = (): JSX.Element => {
  const navigate = useNavigate();
  const view = useSelector(viewSelector);

  const hasChart = menuItems.find(item => item.viewId === view)?.hasChart;

  return (
    <div className={styles.buttonGroup}>
      <Button
        onClick={(): void => {
          navigate(`/views/${view}${hasChart ? '/charts' : ''}`);
        }}>
        Analyse anzeigen
      </Button>
    </div>
  );
};

export default CloseButton;
